import { tokenService } from './tokenService';

/**
 * Fetch user data including token balance from Diet LLM Backend API
 * This replaces the direct Supabase query with the API integration
 */
export const fetchUserData = async (userId) => {
  if (!userId) {
    return {
      tokens: 0,
      lastUpdate: new Date().toISOString(),
      userId: null,
    };
  }

  try {
    // Fetch token balance from Diet LLM Backend API
    const balance = await tokenService.getBalance(userId);
    
    return {
      tokens: balance,
      lastUpdate: new Date().toISOString(),
      userId: userId,
    };
  } catch (error) {
    console.error('Error in fetchUserData:', error);
    // Fallback to default data
    return {
      tokens: 0,
      lastUpdate: new Date().toISOString(),
      userId: userId,
    };
  }
};

/**
 * Fetch subscription status for a user
 */
export const fetchSubscriptionStatus = async (userId) => {
  if (!userId) {
    return { has_subscription: false };
  }

  try {
    return await tokenService.getSubscriptionStatus(userId);
  } catch (error) {
    console.error('Error fetching subscription status:', error);
    return { has_subscription: false };
  }
};
